module.exports = __webpack_public_path__ + "static/media/documentOverlay.ecaae168.svg";